import * as React from 'react';

// Constants
import {
  BALANCE_LIMIT_TYPE,
  LIMIT_TYPE,
  QUOTA_PERIOD
} from '../../../constants';

// Modules
import { DI } from 'modules';

const DSAEnterpriceLimitReached = ({ agreement, common = {} }) => {
  const { quota_period, refill_in } = agreement;
  const { limit_type } = agreement.can_download_content;

  const { strings } = common;

  const buyPlanCln = 'side-buy-plan';
  const prefix = 'page.video.slider.enterprise';

  const isPool = agreement.user_balance.limit_type === BALANCE_LIMIT_TYPE.POOL;

  return (
    <>
      <div className={`${buyPlanCln}__text`}>
        {limit_type === LIMIT_TYPE.USER_LIMIT &&
          strings[`${prefix}.reached_personal_limit`]}

        {quota_period === QUOTA_PERIOD.MONTH ? (
          <>
            {strings[`${prefix}.additions.reached.has_refill_1`]}
            {isPool && strings[`${prefix}.additions.reached.has_refill_2`]}
          </>
        ) : (
          <>
            {strings[`${prefix}.additions.reached.no_has_refill_1`]}
            {isPool && strings[`${prefix}.additions.reached.no_has_refill_2`]}
            {strings[`${prefix}.additions.reached.no_has_refill_3`]}
          </>
        )}
      </div>

      {refill_in && (
        <div className="side-buy-plan__text">
          {strings[`${prefix}.additions.reached.has_refill_3`]}
          {refill_in}
          {strings[`${prefix}.additions.reached.has_refill_4`]}
        </div>
      )}
    </>
  );
};

export default DI(['common'])(DSAEnterpriceLimitReached);
